export const emboldenOverlappingText = (address: string, inputValue: string) => {
    const overlappingTextIndex = address.toLowerCase().indexOf(inputValue.toLowerCase());
    if (overlappingTextIndex === -1) {
        return address;
    }
    const overlappingTextEndIndex = overlappingTextIndex + inputValue.length;
    return <span>{address.slice(0, overlappingTextIndex)}<b>{address.slice(overlappingTextIndex, overlappingTextEndIndex)}</b>{address.slice(overlappingTextEndIndex)}</span>;
};
